// firebase.ts
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyC81TFr72OP0R1pNXkyleUBexlpfumHsuI",
  authDomain: "alexandira-and-morgan-wedding.firebaseapp.com",
  projectId: "alexandira-and-morgan-wedding",
  storageBucket: "alexandira-and-morgan-wedding.firebasestorage.app",
  messagingSenderId: "271219758444",
  appId: "1:271219758444:web:c589d6d27d161752c60f49",
  measurementId: "G-6WHD4BPP7K"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Firebase Authentication
const auth = getAuth(app);

// Initialize Firebase Functions
const functions = getFunctions(app);

// Initialize Firebase Storage (wedding photo gallery)
const storage = getStorage(app);

// Initialize Google Auth Provider
const googleProvider = new GoogleAuthProvider();

export { db, auth, functions, storage, googleProvider };
